import React from "react";
import ComicNavigationActions from "../../model/ComicNavigationActions";
import './ComicControls.scss';

interface ComicControlsProps {
    actions: ComicNavigationActions,
    canGoToPreviousChapter: () => boolean,
    canGoToNextChapter: () => boolean
}

const ComicControls = (props: ComicControlsProps) => {

    return (
        <div className="comic-controls">
            <ul>
                <li>
                    {props.actions.goToFirst
                        ? <button className="active-comic-button" onClick={props.actions.goToFirst}>
                            <img src="/comic/nav/first.png"
                                 alt="First"
                                 title={props.canGoToPreviousChapter() ? "Go to Previous Chapter" : "Go to First Page"}/>
                        </button>
                        : <img className="disabled-comic-button"
                               src="/comic/nav/first.png"
                               alt="First"
                               title="Go to First Page"/>}
                </li>
                <li>
                    {props.actions.goToPrevious
                        ? <button className="active-comic-button" onClick={props.actions.goToPrevious}>
                            <img src="/comic/nav/back.png"
                                 alt="Previous"
                                 title="Go to Previous Page"/>
                        </button>
                        : <img className="disabled-comic-button"
                               src="/comic/nav/back.png"
                               alt="Previous"
                               title="Go to Previous Page"/>}
                </li>
                <li>
                    {props.actions.goToNext
                        ? <button className="active-comic-button" onClick={props.actions.goToNext}>
                            <img src="/comic/nav/forward.png"
                                 alt="Next"
                                 title="Go to Next Page"/>
                        </button>
                        : <img className="disabled-comic-button"
                               src="/comic/nav/forward.png"
                               alt="Next"
                               title="Go to Next Page"/>}
                </li>
                <li>
                    {props.actions.goToLatest
                        ? <button className="active-comic-button" onClick={props.actions.goToLatest}>
                            <img src="/comic/nav/latest.png"
                                 alt="Latest"
                                 title={props.canGoToNextChapter() ? "Go to Next Chapter" : "Go to Latest Page"}/>
                        </button>
                        : <img className="disabled-comic-button"
                               src="/comic/nav/latest.png"
                               alt="Latest"
                               title="Go to Latest Page"/>}
                </li>
            </ul>
        </div>
    );
}

export default ComicControls;